import { create } from 'zustand';

const useCustomModal = create((set, get) => ({
  open: false,
  // open: true,
  ref: null,
  setRef: node => {
    set({ ref: node });
  },
  setOpen: (open) => set({ open }),
  closeMainModal: () => set({ open: false }),
}));

export default useCustomModal;